import { gql } from 'apollo-angular';

export const RemoveCustomPromptDocument = gql(/* GraphQL*/ `mutation removeCustomPrompt($customPromptId: Int!) {
    removeCustomPrompt(customPromptId: $customPromptId)
  }
`);
